import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import type { HsSectionAxis } from '@sibe/hyperscene/tools/section';
import type { HypersceneAdvancedDemo } from '../../hyperscene-advanced.component';

/**
 * The Tools tab: selection actions, clipping, measurements, markers and viewer data transfer. The page owns the state;
 * this component only renders it, so it is checked with the page.
 */
@Component({
  selector: 'section[viewer-tools-panel]',
  templateUrl: './viewer-tools-panel.component.html',
  changeDetection: ChangeDetectionStrategy.Default,
  standalone: false,
})
export class ViewerToolsPanelComponent {
  @Input({ required: true }) public viewer!: HypersceneAdvancedDemo;

  /** Axes of the section box sliders, and where each sits in a box's corners. */
  public readonly sectionAxes: readonly HsSectionAxis[] = ['x', 'y', 'z'];
  public readonly axisIndex: Readonly<Record<HsSectionAxis, number>> = { x: 0, y: 1, z: 2 };
}
